"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const js_logger_1 = __importDefault(require("js-logger"));
const nucleus_1 = require("@lifesize/nucleus");
const remoting_1 = __importDefault(require("../actions/remoting"));
const pairing_1 = __importDefault(require("../actions/pairing"));
const Remoting = __importStar(require("../constants/remoting"));
const Pairing = __importStar(require("../constants/pairing"));
const remoting_2 = __importDefault(require("../utils/remoting"));
const { WAMP_CONNECT_SUCCESS, WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC } = nucleus_1.nucleusConstants;
const graphiteEventReceivedMap = {
    [Remoting.service.events.types.actionReceived]: handleActionReceived,
    [Remoting.service.events.types.remoteStateUpdated]: handleRemoteStateUpdated,
    [Remoting.service.events.types.stateRequested]: handleStateRequested,
    [Remoting.service.events.types.displayPaired]: handleDisplayPaired,
    [Remoting.service.events.types.displayUnpaired]: handleDisplayUnpaired
};
const remotingActionMap = {
    [Remoting.actions.GRAPHITE_EVENT_RECEIVED]: handleGraphiteEventReceived,
    [Pairing.actions.REQUEST_PIN_CHANGE]: handleRequestPinChange,
    [WAMP_CONNECT_SUCCESS]: handleLoginSuccessful
};
function handleActionReceived(store, action) {
    const proxyActionType = get_1.default(action, 'payload.value.action');
    const proxyFrom = get_1.default(action, 'payload.from');
    const proxyPayload = get_1.default(action, 'payload.value.payload');
    remoting_2.default.handleProxyAction(store, proxyActionType, proxyPayload, proxyFrom);
}
function handleRemoteStateUpdated(store, action) {
    const remoteState = get_1.default(action, 'payload.value');
    store.dispatch(remoting_1.default.remoteStateUpdated(remoteState));
}
function handleStateRequested(store, action) {
    const proxyFrom = get_1.default(action, 'payload.from');
    const dataChannelFrom = get_1.default(action, 'payload.value.from');
    const state = store.getState();
    const pairedUuid = get_1.default(state, 'app.remoting.pairing.pairedUuid');
    if (proxyFrom === pairedUuid || dataChannelFrom === pairedUuid) {
        remoting_2.default.sendState(store, state, true);
    }
    else {
        remoting_2.default.sendPresenterState(store, state, true);
    }
}
function handleDisplayPaired(store, action) {
    store.dispatch(remoting_1.default.displayPaired(get_1.default(action, 'payload.value')));
}
function handleDisplayUnpaired(store) {
    store.dispatch(remoting_1.default.displayUnpaired());
}
function handleGraphiteEventReceived(store, action) {
    const eventType = get_1.default(action, 'payload.type');
    const graphiteEventReceivedHandler = graphiteEventReceivedMap[eventType];
    if (graphiteEventReceivedHandler)
        graphiteEventReceivedHandler(store, action);
}
function handleRequestPinChange(store, action) {
    const uuid = get_1.default(store.getState(), 'app.remoting.pairing.uuid');
    const newPin = get_1.default(action, 'payload');
    if (!newPin || !uuid) {
        return;
    }
    return store
        .dispatch(nucleus_1.proxyActions.proxyApiCall(Pairing.deviceInfoService.name, Pairing.deviceInfoService.actions.update, 'POST', {
        deviceUUID: uuid,
        devicePin: newPin
    }))
        .then(response => {
        const { statusCode } = JSON.parse(response);
        if (statusCode && statusCode >= 400) {
            return js_logger_1.default.error('Updating PIN got a bad status code');
        }
        store.dispatch(pairing_1.default.setLocalPin(newPin));
    })
        .catch(reason => js_logger_1.default.error('Updating PIN hit an error', reason));
}
function handleLoginSuccessful(store) {
    const state = store.getState();
    const uuid = get_1.default(state, 'app.remoting.pairing.uuid');
    const isDisplay = get_1.default(state, 'app.remoting.pairing.isDisplay');
    if (!isDisplay || !uuid) {
        return;
    }
    return store
        .dispatch(nucleus_1.proxyActions.proxyApiCall(Pairing.deviceInfoService.name, Pairing.deviceInfoService.actions.get, 'GET', {
        deviceUUID: uuid
    }))
        .then(response => {
        const { body, statusCode } = JSON.parse(response);
        const responseBody = body && JSON.parse(body);
        if (statusCode && statusCode >= 400) {
            return js_logger_1.default.error('Getting PIN from deviceinfo failed');
        }
        const { devicePin } = get_1.default(responseBody, 'deviceInfo') || {};
        if (!devicePin) {
            return;
        }
        store.dispatch(pairing_1.default.setLocalPin(devicePin));
    })
        .catch(reason => js_logger_1.default.error('Getting PIN from deviceinfo failed', reason));
}
const remotingMiddleware = store => next => action => {
    const result = next(action);
    const remotingActionHandler = remotingActionMap[action.type];
    if (remotingActionHandler) {
        remotingActionHandler(store, action);
    }
    const state = store.getState();
    const isDisplay = get_1.default(state, 'app.remoting.pairing.isDisplay');
    const isServicesConnected = nucleus_1.servicesSelectors.selectConnected(state);
    const isLinkedToRemote = !!get_1.default(state, 'app.remoting.pairing.pairedUuid');
    const canSend = isServicesConnected && isLinkedToRemote;
    if (isDisplay) {
        const hasPresenters = !!get_1.default(state, 'app.remoting.pairing.presenters.length');
        if (canSend &&
            (!action.type.includes('WAMP') || action.type === WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC) &&
            !action.type.includes('SOCKET') &&
            !action.type.includes('REDUX') &&
            !action.type.includes(Remoting.actions.DATA_CHANNEL_OPENED) // Handled in the data channel middleware
        ) {
            // update the remote (tablet)
            remoting_2.default.sendState(store, state);
            // update the wireless presenter(s) (if any exist)
            if (hasPresenters) {
                remoting_2.default.sendPresenterState(store, state);
            }
        }
        else if (action.type === Pairing.actions.REMOTE_UNLINK_SUCCESS && hasPresenters) {
            remoting_2.default.sendPresenterState(store, state);
        }
    }
    return result;
};
exports.default = remotingMiddleware;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/middlewares/remoting.js
// module id = 535
// module chunks = 0